import React from "react";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const PencilIcon = ({
  height = normalize(25),
  width = normalize(24),
  color = theme.colors["neutral.900"],
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    {...props}
    viewBox="0 0 25 24"
    preserveAspectRatio="xMidYMin meet"
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.93435 14.8983L6.66977 17.2778C6.63435 17.5961 6.9033 17.8653 7.22163 17.8301L9.59948 17.5676L17.0403 10.127C17.4309 9.73614 17.4309 9.10283 17.0403 8.71221L15.7881 7.45995C15.3975 7.06934 14.7639 7.06934 14.3733 7.45995L6.93435 14.8983ZM14.1145 8.94446L14.9861 8.07278C15.0383 8.02062 15.1231 8.02062 15.1752 8.07278L16.4275 9.32504C16.4796 9.37711 16.4798 9.46181 16.4273 9.5143L15.5558 10.3858L14.1145 8.94446ZM14.943 10.9986L9.20188 16.7396L7.58174 16.9184L7.76211 15.2962L13.5016 9.55727L14.943 10.9986Z"
      fill={color}
    />
  </Svg>
);

export default PencilIcon;
